import * as React from 'react';

// Components
import Button from '../Button';
import { NotFound } from '@shopee-user/shared-customization-ui';

// Hooks
import { useTranslation } from '@shopee-user/platform';

import styles from './style.scss';

type Props = {
  title?: string;
  subtitle?: string;
};

const GeneralError = ({ title, subtitle }: Props) => {
  const I18n = useTranslation();
  return (
    <NotFound
      title={title || I18n.t('msg_error_default_title')}
      subtitle={subtitle || I18n.t('msg_error_default_subtitle')}
      actionButton={
        <Button
          text={I18n.t('label_refresh')}
          onClick={() => window.location.reload()}
          className={styles.refreshButton}
        />
      }
      className={styles.styleCenterAndFixed}
    />
  );
};

export default GeneralError;
